import React from 'react';
import { ArtandCraftWorkshop2026 } from '../views';

const DesktopAppPage = () => {
  return <ArtandCraftWorkshop2026/>;
};
export default DesktopAppPage;
